module.exports = __webpack_public_path__ + "static/img/clean.00d6779f.png";